import { useGenericRequestHandler } from '../../handlers/useGenericRequestHandler'

export const useSchoolSearchMutation = () => {
  return useGenericRequestHandler({
    route: 'v1/x/searchInstitutions',
    method: 'POST'
  })
}
